<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>企业详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="inputDiv">
      <div class="inputDiv">
        <div>
          登陆账号：
          <span>{{enterprise.userName}}</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          有效期至：
          <span>{{enterprise.validity}}</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          公司限定人数：
          <span>{{enterprise.employeesLimit}}</span>
        </div>
      </div>
    </div>
    <el-row :gutter="0"
            class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">公司名称：</div>
          <el-input v-model="enterprise.name"
                    style="width: unset;"
                    :disabled="inputDisabled"
                    placeholder="请输入公司名称"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">负责人名称：</span>
          <el-input v-model="enterprise.contacts"
                    :disabled="inputDisabled"
                    class="inputRight"
                    style="width: unset;"
                    placeholder="请输入负责人名称"></el-input>
        </div>

        <div class="inputDiv">
          <span class="inputLeft">上午上班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          :disabled="inputDisabled"
                          v-model="workingTime.toWork1"
                          :picker-options="{
               start: '04:00',
               step: '00:05',
               end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">下午上班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          :disabled="inputDisabled"
                          v-model="workingTime.toWork2"
                          :picker-options="{
               start: '04:00',
               step: '00:05',
               end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <!-- <div class="inputDiv">

        </div> -->
        <div class="inputDiv">
          <div class="inputLeft">地址：</div>
          <el-input v-model="enterprise.province"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="省"></el-input>
          <el-input v-model="enterprise.city"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="市"></el-input>
          <el-input v-model="enterprise.county"
                    class="inputdi"
                    style="width: unset;"
                    :disabled="true"
                    placeholder="区"></el-input>
        </div>
      </el-col>

      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">负责人电话：</div>
          <el-input v-model="enterprise.tel"
                    :disabled="inputDisabled"
                    maxlength="11"
                    style="width: unset;"
                    placeholder="请输入负责人电话"></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">工资隐藏：</span>
          <el-select v-model="enterprise.priceHide"
                     :disabled="inputDisabled"
                     placeholder>
            <el-option v-for="item in priceHideList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>

        <div class="inputDiv">
          <span class="inputLeft">上午下班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          :disabled="inputDisabled"
                          v-model="workingTime.offWork1"
                          :picker-options="{
               start: '04:00',
               step: '00:05',
               end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">下午下班时间：</span>
          <el-time-select class="inputRight"
                          style="width: unset;"
                          :disabled="inputDisabled"
                          v-model="workingTime.offWork2"
                          :picker-options="{
               start: '04:00',
               step: '00:05',
               end: '23:30'
            }"
                          placeholder="选择时间"></el-time-select>
        </div>
        <div class="inputDiv">
          <el-input type="textarea"
                    :rows="1"
                    placeholder="请输入详细地址"
                    :disabled="inputDisabled"
                    v-model="enterprise.address"></el-input>
        </div>
      </el-col>
    </el-row>

    <baidu-map class="map"
               style="height: 400px"
               :center="center"
               :scroll-wheel-zoom="!inputDisabled"
               @ready="mapReady"
               @click="getPoint"
               :zoom="15">
      <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
      <bm-marker v-if="point!=''"
                 :position="point"
                 animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
    </baidu-map>

    <div class="inputDiv">
      <!-- <el-button type="primary"
      class="widthButton">修改密码</el-button>-->
      <el-button type="primary"
                 class="widthButton"
                 @click="onEdit">{{edit}}</el-button>
      <el-button class="widthButton"
                 @click="goback">取消</el-button>
    </div>
  </div>
</template>

<script>
import { enterpriseSel, enterpriseMod } from "@/api/enterprise";
import { getEnterpriseStates } from "@/util/enum";
import {
  bd09togcj02,
  gcj02towgs84,
  wgs84togcj02,
  gcj02tobd09
} from "@/util/coordtransform";
export default {
  data () {
    return {
      edit: "编辑",
      inputDisabled: true,
      geoCoder: {},
      address: {},
      BMapP: null,
      center: { lng: 0, lat: 0 },
      point: "",
      workingTime: {},
      enterprise: {
        name: "",
        contacts: "",
        employeesLimit: "",
        industry: 1,
        userName: "",
        tel: "",
        pass: "",
        priceHide: 1
      },
      priceHideList: [
        {
          value: 0,
          label: "不隐藏"
        },
        {
          value: 1,
          label: "隐藏"
        },
      ],
    };
  },
  mounted () {
    this.enterprise = this.$route.query;
    setTimeout(this.getEnterpriseList, 500);
  },
  methods: {
    getPoint (e) {
      if (this.inputDisabled) {
        return;
      }
      this.point = e.point;
      this.geoCoder.getLocation(e.point, rs => {
        const addComp = rs.addressComponents;
        this.enterprise.province = addComp.province;
        this.enterprise.city = addComp.city;
        this.enterprise.county = addComp.district;
        this.enterprise.address = addComp.street + addComp.streetNumber;
        if (rs.surroundingPois.length > 0 && rs.surroundingPois[0].title) {
          this.enterprise.address += " : " + rs.surroundingPois[0].title;
        }
      });
    },
    mapReady (e) {
      const BMap = e.BMap;
      this.BMapP = BMap.Point;
      if (this.point) {
        this.point = new this.BMapP(this.point[0], this.point[1]);
        this.center = this.point;
      } else {
        this.point = new BMap.Point(0, 0);
      }
      this.geoCoder = new BMap.Geocoder();
    },
    onEdit () {
      if (this.inputDisabled) {
        this.inputDisabled = false;
        this.edit = "确定";
      } else {
        this.inputDisabled = true;
        this.edit = "编辑";
        this.updata();
      }
    },
    getEnterpriseList () {
      const params = {
        id: this.enterprise.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      enterpriseSel(params)
        .then(res => {
          res.gridData[0].state = getEnterpriseStates(res.gridData[0].states);
          this.enterprise = res.gridData[0];
          const workingTime = this.enterprise.workingTime.split(";");
          this.workingTime = {
            toWork1: workingTime[0].split("-")[0], //早上上班时间
            offWork1: workingTime[0].split("-")[1], //早上下班时间
            toWork2: workingTime[1].split("-")[0], //下午上班时间
            offWork2: workingTime[1].split("-")[1] //下午下班时间
          };
          let point = wgs84togcj02(this.enterprise.lon, this.enterprise.lat);
          this.point = gcj02tobd09(point[0], point[1]);
          if (this.BMapP) {
            this.point = new this.BMapP(this.point[0], this.point[1]);
            this.center = this.point;
          }
        })
        .catch();
    },
    updata () {
      if (
        !this.workingTime.toWork1 &&
        !this.workingTime.offWork1 &&
        !this.workingTime.toWork2 &&
        !this.workingTime.offWork2
      ) {
        this.$message({
          type: "error",
          message: "请输入上下班时间！"
        });
        return;
      }
      const gcj02 = bd09togcj02(this.point.lng, this.point.lat);
      const wgs84 = gcj02towgs84(gcj02[0], gcj02[1]);
      const params = {
        id: this.enterprise.id,
        name: this.enterprise.name,
        contacts: this.enterprise.contacts,
        tel: this.enterprise.tel,
        address: this.enterprise.address,
        priceHide: this.enterprise.priceHide,
        lon: wgs84[0],
        lat: wgs84[1],
        workingTime:
          this.workingTime.toWork1 +
          "-" +
          this.workingTime.offWork1 +
          ";" +
          this.workingTime.toWork2 +
          "-" +
          this.workingTime.offWork2
      };
      enterpriseMod(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.goback();
        })
        .catch(err => {
          console.log(err);
        });
    },
    goback () {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>
